// /src/pages/private/members/academyTools/hooks/useMemberAcademyCatalog.js

import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useSecurity } from '../../../../../SecurityContext';

export function useMemberAcademyCatalog({ enabled = true } = {}) {
  const { isViewAsActive, viewAsUserId } = useSecurity();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [catalog, setCatalog] = useState(null);
  const [selectedCourseId, setSelectedCourseId] = useState(null);

  const fetchCatalog = useCallback(async () => {
    if (!enabled) {
      setLoading(false);
      setCatalog(null);
      return;
    }

    setLoading(true);
    setError('');

    try {
      const res = await axios.post('/api/user/academy/catalog', {}, { withCredentials: true });
      const data = res.data?.data || { courses: [] };
      setCatalog(data);

      const courses = data.courses || [];
      setSelectedCourseId((prev) => {
        if (prev && courses.some((course) => course.id === prev)) return prev;
        return courses[0]?.id ?? null;
      });
    } catch (err) {
      console.error('Failed to load member academy catalog', err);
      setError('Could not load academy courses.');
      setCatalog(null);
      setSelectedCourseId(null);
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    fetchCatalog();
  }, [fetchCatalog, isViewAsActive, viewAsUserId]);

  const selectedCourse = (catalog?.courses || []).find(
    (course) => course.id === selectedCourseId
  ) || null;

  return {
    loading,
    error,
    catalog,
    courses: catalog?.courses || [],
    selectedCourseId,
    selectedCourse,
    setSelectedCourseId,
    refetch: fetchCatalog,
  };
}
